import { GetPricingPageQuery } from "~/gql/queries/tenantPricing.generated";

export const pricingPageEndpoints = {
	GetPricingPage: {
		providesTags: ["PricingPage"] as AddTagTypes,
		transformResponse: (res: GetPricingPageQuery) => res
	}
};
